"use client";
import React, { useEffect, useState } from "react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa6";
import ReactPaginate from "react-paginate";
import PaginatedList from "./PaginatedList";

const ItemComponent = ({ item }) => {
  return (
    <>
      {item.title && item.url && (
        <div>
          <a
            href={item.url}
            target="_blank"
            className="underline underline-offset-2"
          >
            {item.title}
          </a>
          <p>{item.description}</p>
        </div>
      )}
    </>
  );
};

export default function SpotlightReportAndProspectPagination(props) {
  const { items, itemsPerPage, wrapperClassName } = props;
  return (
    <PaginatedList
      items={items}
      itemsPerPage={itemsPerPage}
      wrapperClassName={wrapperClassName}
      ItemComponent={ItemComponent}
    />
  );
}
